const AMPLITUDE_EVENT_TYPES = {
    PAIRING: 'Device Paired',
    CONNECTING: 'Device Connected',
    ABOUT_MY_DEVICE: 'About My Device Viewed',
    RENAME_DEVICE: 'Device Renamed',
    VIBRATION_SETTINGS_TOGGLED: 'Vibration Settings Toggled',
    USAGE_STATISTICS_VIEWED: 'Usage Statistics Viewed',
    TIPS_AND_TUTORIALS_VIEWED: 'Tips & Tutorials Viewed',
    DEVICE_SCREEN_VIEWED: 'Device Screen Viewed',
    LOCK_SELECTED: 'Lock Selected',
    AUTO_START_SELECTED: 'Auto-Start Selected',
    FLEX_PUFF_SELECTED: 'FlexPuff Selected',
    FLEX_BATTERY_SELECTED: 'FlexBattery Selected',
    PAUSE_MODE_SELECTED: 'Pause Mode Selected',
    PAUSE_MODE_GUIDE_VIEWED: 'Pause Mode Guide Viewed',
    ILLUMINATION_MODE_SELECTED: 'Illumination Mode Selected',
    SMART_GESTURES_SELECTED: 'Smart Gestures Selected',
    VAPE_CLOUD_SIZE_SELECTED: 'Vape Cloud Size Selected',
    RESPONSIVE_DRAW_SELECTED: 'Responsive Draw (P4) Selected',
    VAPING_SESSION_SELECTED: 'Vaping Session Selected',
    AUTO_CLEANING_STARTED: 'Auto-Cleaning Started',
    AUTO_CLEANING_COMPLETED: 'Auto-Cleaning Completed',
    LOCATE_MY_DEVICE_STARTED: 'Locate My Device Started',
    LOCATE_MY_DEVICE_COMPLETED: 'Locate My Device Completed',
    RESET_DEVICE_STARTED: 'Reset Device Started',
    RESET_DEVICE_COMPLETED: 'Reset Device Completed',
    UNPAIR_DEVICE_STARTED: 'Unpair Device Started',
    UNPAIR_DEVICE_COMPLETED: 'Unpair Device Completed',
    DEVICE_DATA_COLLECTION_COMPLETED: 'Device Data Collection Completed',
    TRADE_IN_CLICKED: 'Trade In Clicked',
    LINK_TO_NEAREST_STORE_OPENED: 'Link to Nearest Store Opened',
    ANNIVERSARY_LEARN_MORE_CLICKED: 'Anniversary Campaign Viewed',
    REGISTRATION_STARTED: 'Registration Started',
    REGISTRATION_COMPLETED: 'Registration Completed',
    FIRMWARE_UPGRADE_STARTED: 'Firmware Upgrade Started',
    FIRMWARE_UPGRADE_COMPLETED: 'Firmware Upgrade Completed',
    CONNECTED_CARE_DIAGNOSIS_VIEWED: 'Connected Care Diagnosis Viewed',
    AD_STARTED: 'Advanced Diagnostics Started',
    AD_INITIAL_QUESTIONNAIRE_VIEWED: 'Advanced Diagnostics Initial Questionnaire Viewed',
    AD_AUTO_DIAGNOSTICS_STARTED: 'Advanced Diagnostics Auto Diagnostics Started',
    AD_COMPLETED: 'Advanced Diagnostics Completed',
    AD_COMPLETED_RESOLUTION_SCREEN: 'Advanced Diagnostics Resolution Screen',
    KODAK_CHECK_COMPATIBILITY_SCREEN: 'Kodak Check Compatibility Screen',
    KODAK_LEARN_MORE_SCREEN: 'Kodak Learn More Screen',
    KODAK_UPDATE_FIRMWARE_SCREEN: 'Kodak Update Firmware Screen',
    KODAK_LEAR_MORE_CLICKED: 'Kodak Learn More Clicked',
};

export default AMPLITUDE_EVENT_TYPES;
